// extracted by mini-css-extract-plugin
module.exports = {"incidents":"Incidents_incidents__3iB16","incidentList":"Incidents_incidentList__3Ie0J","filterBar":"Incidents_filterBar__2l-Oy"};